import { createBrowserHistory } from 'history'
import { useEffect, useState } from 'react'
import { sections as rawSections } from '../../../../utils/constants'
import { useMenu } from '../menu'
import { useTranslation } from 'react-i18next'

export const useBreadcrumb = () => {
  const { t } = useTranslation()
  const { items } = useMenu()
  const [section, setSection] = useState('')
  const [breadcrumbs, setBreadcrumbs] = useState(null)
  const [path, setPath] = useState('/')
  const history = createBrowserHistory()

  const sections = rawSections({ t })

  const handleSection = (breadcrumb) => {
    let newSection = ''
    const pathName = `/${history.location.pathname.split('/')[1]}`
    if (pathName == '/home') {
      newSection = t('sections.home')
    } else if (history.location.pathname === sections.profile.path) {
      newSection = t('sections.profile')
      return setSection(newSection)
    } else if (history.location.pathname === sections.security.path) {
      newSection = t('sections.security')
      return setSection(newSection)
    } else if (history.location.pathname === '/users/settings') {
      newSection = t('sections.settings')
      return setSection(newSection)
    } else if (history.location.pathname === sections.help.path) {
      newSection = t('sections.help')
      return setSection(newSection)
    } else if (history.location.pathname.includes(sections.accounts.path)) {
      newSection = t('account.title')
      return setSection(newSection)
    } else if (history.location.pathname.includes(sections.team.path)) {
      newSection = t('sections.team')
      return setSection(newSection)
    } else if (history.location.pathname.includes('/create-role')) {
      newSection = t('sections.team')
      return setSection(newSection)
    } else if (history.location.pathname.includes('/edit-role')) {
      newSection = 'Edit role'
      return setSection(newSection)
    } else if (history.location.pathname.includes('/users/roles/management')) {
      newSection = t('sections.team')
      return setSection(newSection)
    } else if (history.location.pathname.includes('/insights')) {
      newSection = 'Insights'
      setPath('/insights')
      return setSection(newSection)
    } else if (history.location.pathname.includes('/reconciliations')) {
      newSection = t('sections.reconciliations')
      setPath('/reconciliations')
      return setSection(newSection)
    } else if (history.location.pathname.includes('/payment-links')) {
      newSection = t('sections.paymentLinks')
      setPath('/payment-links')
      return setSection(newSection)
    } else if (history.location.pathname.includes('/payments/transactions')) {
      newSection = t('sections.transactions')
      return setSection(newSection)
    } else if (history.location.pathname.includes('/payments')) {
      newSection = t('sections.payments')
      return setSection(newSection)
    } else if (items) {
      newSection = items.find((t) => t.pathname === pathName)?.text
    }
    setPath(breadcrumb ? pathName : null)
    setSection(newSection)
    breadcrumb ? setBreadcrumbs([breadcrumb]) : setBreadcrumbs(null)
  }

  useEffect(() => {
    if (items) {
      handleSection(localStorage.getItem('breadcrumb'))
    }
  }, [items])

  window.addEventListener('popstate', () => {
    handleSection(localStorage.getItem('breadcrumb'))
  })

  return {
    section,
    breadcrumbs,
    path,
    history,
    handleSection,
    setBreadcrumbs,
  }
}
